import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {UrlBuilderService} from '../../../services/url-builder.service';
import {SearchResultsCareproviderUnitItem} from '../../../types/SearchResultsCareproviderUnitItem';
import {AppConfigService} from '../../../services/app-config.service';

@Component({
  selector: 'app-closeby-provider-card-v2',
  templateUrl: './closeby-provider-card-v2.component.html',
  styleUrls: ['./closeby-provider-card-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClosebyProviderCardV2Component {
  public puffDataMultitype = input<any>(null);
  public index = input<number>(null);
  public careProvider = input<SearchResultsCareproviderUnitItem>(null);

  public careProviderToDisplay = computed<SearchResultsCareproviderUnitItem>(() =>
    this.puffDataMultitype() ? (this.puffDataMultitype() as SearchResultsCareproviderUnitItem) : this.careProvider(),
  );
  public hasImage = computed<boolean>(() => !!this.careProviderToDisplay()?.thumbnail);
  public mainSegment = computed<string>(() =>
    this.careProviderToDisplay()?.mainCaregiverUnitType?.segment?.name?.toLowerCase(),
  );
  public imageUrl = computed<string>(() =>
    this.careProviderToDisplay()?.thumbnail
      ? `${this.appConfigService.appConfig.amazonS3Url}${this.careProviderToDisplay().thumbnail}`
      : `${this.appConfigService.appConfig.amazonS3Url}assets/hsa-default.jpg`,
  );
  public careproviderUrl = computed<string>(() =>
    this.urlBuilder.CreateStaticLink(
      this.urlBuilder.CreateCareproviderUnitRouterLink(
        this.careProviderToDisplay()?.id,
        this.careProviderToDisplay()?.urlPath,
      ),
    ),
  );

  constructor(
    private urlBuilder: UrlBuilderService,
    private appConfigService: AppConfigService,
  ) {}
}
